// Mint-TMS-Phone · khung 2 "Lịch trực của tôi" (THANH). Dữ liệu mẫu đúng dòng + thứ tự của board (DA).
export type DutyWeek = 'A' | 'B';
export type DutyDay = readonly [day: string, shift: string, tag?: string];

export const DUTY_WEEKS: ReadonlyArray<{ key: DutyWeek; label: string }> = [
  { key: 'A', label: 'Tuần A · 19–25/Oct' },
  { key: 'B', label: 'Tuần B · 26/Oct' },
];

export const DUTY_DAYS: Record<DutyWeek, readonly DutyDay[]> = {
  A: [
    ['T2 19', 'Sáng sớm 06–08 · hành chính'],
    ['T3 20', 'Sáng sớm 06–08 · hành chính'],
    ['T4 21', 'Sáng sớm 06–08 · hành chính'],
    ['T5 22', 'Sáng sớm 06–08 · hành chính', 'Hôm nay'],
    ['T6 23', 'Sáng sớm 06–08 · hành chính'],
    ['T7 24', 'Sáng sớm 06–08 · sáng VP'],
    ['CN 25', 'Nghỉ · PHONG trực'],
  ],
  B: [
    ['T2 26', 'Hành chính · tối 17:30–23'],
    ['T3 27', 'Hành chính · tối 17:30–23'],
    ['T4 28', 'Hành chính · tối 17:30–23'],
    ['T5 29', 'Hành chính · tối 17:30–23'],
    ['T6 30', 'Hành chính · tối 17:30–23'],
    ['T7 31', 'Sáng VP · chiều + tối từ xa'],
    ['CN 01', 'Trực cả ngày 06–23 từ xa'],
  ],
};

/** OT tháng 10: 6,5h / 40h (board: bề rộng thanh 16%). */
export const DUTY_OT = { done: 6.5, cap: 40, shifts: 12, tip: '23:00–06:00 chỉ gọi sự cố nghiêm trọng. P0 chưa nhận sau 15′ chuyển PHONG, rồi BOD.' };
export const dutyOtPct = () => Math.round((DUTY_OT.done / DUTY_OT.cap) * 100);
